import axios from 'axios'
import Cookies from 'js-cookie'
// import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import {
  $alert,
  $error
} from './message'
import {
  getToken
} from '@/utils/auth'
import Config from '@/settings'
import i18n from '@/lang'
import {
  tryShowLoading,
  tryHideLoading
} from './loading'
import {
  getLinkToken,
  setLinkToken
} from '@/utils/auth'
// import router from '@/router'
const TokenKey = Config.TokenKey
const RefreshTokenKey = Config.RefreshTokenKey
const LinkTokenKey = Config.LinkTokenKey
const extraConfig = JSON.parse(localStorage.getItem('dataEaseConfig'))
console.log(decodeURI(window.location.href))
// Cookies.set(TokenKey,  `${decodeURI(window.location.href).split('=')[1]}`)
const token = `${decodeURI(window.location.href).split('=')[1]}`
localStorage.setItem('token', token)
// create an axios instance
const service = axios.create({
  baseURL: extraConfig.VUE_APP_BASE_API, //"http://192.168.66.115:8081/", // url = base url + request url // currentEnv.VUE_APP_BASE_API
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 0 // request timeout
})
// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    console.log(getToken(), 12121)
    if (token) {
      config.headers[TokenKey] = token
    }

    if (i18n.locale) {
      const lang = i18n.locale.replace('_', '-')
      config.headers['Accept-Language'] = lang
    }
    // 增加loading

    config.loading && tryShowLoading(store.getters.currentPath)

    return config
  },
  error => {
    error.config.loading && tryHideLoading(store.getters.currentPath)
    // do something with request error
    return Promise.reject(error)
  }
)

const checkAuth = response => {
  // 请根据实际需求修改

  if (response.headers['authentication-status'] === 'login_expire') {
    const message = i18n.t('login.expires')
    // store.dispatch('user/setLoginMsg', message)
    $alert(message, () => {
      store.dispatch('user/logout').then(() => {
        location.reload()
      })
    })
  }

  if (response.headers['authentication-status'] === 'invalid') {
    const message = i18n.t('login.tokenError')
    $alert(message, () => {
      store.dispatch('user/logout').then(() => {
        location.reload()
      })
    })
  }
  // token到期后自动续命 刷新token
  if (response.headers[RefreshTokenKey]) {
    const refreshToken = response.headers[RefreshTokenKey]
    store.dispatch('user/refreshToken', refreshToken)
  }

  if (response.headers[LinkTokenKey.toLocaleLowerCase()]) {
    const linkToken = response.headers[LinkTokenKey.toLocaleLowerCase()]
    setLinkToken(linkToken)
  }
  // 许可状态改变 刷新页面
  //   if (response.headers['lic-status']) {
  //     location.reload()
  //   }
}

// 请根据实际需求修改
service.interceptors.response.use(response => {
  response.config.loading && tryHideLoading(store.getters.currentPath)
  checkAuth(response)
  return response.data
}, error => {
  if (error.response && error.response.data && error.response.data.message.includes('token已过期')) {
    console.log(error.response.data.message.includes('token已过期'))
    window.parent.postMessage('token已过期', extraConfig.VUE_APP_BS_PAGE)
    return
  }
  const config = error.response && error.response.config || error.config
  const headers = error.response && error.response.headers || error.response || config.headers
  config.loading && tryHideLoading(store.getters.currentPath)

  let msg
  if (error.response) {
    checkAuth(error.response)
    // checkPermission(error.response)
    msg = error.response.data.message || error.response.data
  } else {
    msg = error.message
  }!config.hideMsg && (!headers['authentication-status']) && $error(msg)
  return Promise.reject(error)
})
export default service
